import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

export type ComparisonRow = {
  id: string;
  folio: string;
  amountToConciliate: number;
  totalRemainingNet: number;
  hasFutureConciliations: boolean;
};

type ApplicationsInOperationWarningsProps = {
  hasAmountDifferences: boolean;
  hasFutureConciliations: boolean;
  allowOperationIfFutureConciliations: boolean;
  comparisonsWithWarnings: ComparisonRow[];
};

const ApplicationsInOperationWarnings = (
  props: ApplicationsInOperationWarningsProps,
) => {
  const {
    hasAmountDifferences,
    hasFutureConciliations,
    allowOperationIfFutureConciliations,
    comparisonsWithWarnings,
  } = props;
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2, '& .MuiAlert-message': { width: '100%' } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {hasAmountDifferences && (
          <Typography variant="body1">
            Se han encontrado diferencias en los documentos aplicados en esta
            solicitud entre los montos aplicados y los saldos restantes. Por
            favor, confirma que los montos a aplicar son correctos.
          </Typography>
        )}
        {hasFutureConciliations && allowOperationIfFutureConciliations && (
          <Typography variant="body1">
            Se han encontrado conciliaciones futuras a las aplicaciones en
            algunos de los documentos aplicados en esta solicitud. Por favor,
            confirma que los montos a aplicar son correctos.
          </Typography>
        )}
        {hasFutureConciliations && !allowOperationIfFutureConciliations && (
          <Typography variant="body1">
            Se han encontrado conciliaciones futuras a las aplicaciones en
            algunos de los documentos aplicados en esta solicitud.{' '}
            <strong>No se puede continuar con el flujo de la solicitud</strong>.
          </Typography>
        )}
        <TableContainer
          sx={{
            maxWidth: 640,
            mt: 1,
            borderRadius: 1,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'warning.dark',
            bgcolor: 'background.paper',
            boxShadow: 1,
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell variant="head">Folio documento aplicado</TableCell>
                <TableCell variant="head">Monto aplicado</TableCell>
                <TableCell variant="head">Saldo</TableCell>
                <TableCell variant="head">Conciliaciones futuras</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comparisonsWithWarnings.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    bgcolor: index % 2 === 1 ? 'action.hover' : 'transparent',
                    '&:last-child td': { borderBottom: 0 },
                    '& td': {
                      py: 1.25,
                      fontSize: '0.8125rem',
                    },
                  }}
                >
                  <TableCell>{row.folio}</TableCell>
                  <TableCell>{formatMoney(row.amountToConciliate)}</TableCell>
                  <TableCell>{formatMoney(row.totalRemainingNet)}</TableCell>
                  <TableCell>
                    {row.hasFutureConciliations ? 'Sí' : 'No'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Alert>
  );
};

export default ApplicationsInOperationWarnings;
